import { useState, useEffect } from 'react';
import { axiosInstance } from '../../../../api/axios';
import APIEndpoints from '../../../api/APIEndpoints';
import { useSelector } from 'react-redux';

const usePasswordRecovery = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [currentStep, setCurrentStep] = useState(1);
  const [OTPExpiry, setOTPExpiry] = useState(0);
  const [OTPLength, setOTPLength] = useState(0);
  const [OTPAttempts, setOTPAttempts] = useState(0);
  const [passwordRules, setPasswordRules] = useState({});
  const [userDetails, setUserDetails] = useState({});
  const [skeletonLoader, setSkeletonLoader] = useState(false);
  const { bearerToken } = useSelector((state) => state?.user);

  const nextStep = () => {
    setCurrentStep(currentStep + 1);
  };

  const prevStep = () => {
    setCurrentStep(currentStep - 1);
  };

  const setOTPConfig = async () => {
    setSkeletonLoader(true);
    const responseConfiguration = await axiosInstance.get(
      APIEndpoints.getAdminConfigResources(),
    );
    const adminConfig = responseConfiguration.data;
    setOTPExpiry(adminConfig?.Response?.InsurerClientSettings?.OTPExpiresIn);
    setOTPLength(adminConfig?.Response?.InsurerClientSettings?.OTPLength);
    setOTPAttempts(
      adminConfig?.Response?.InsurerClientSettings?.InvalidOTPAttempts,
    );
    setPasswordRules(adminConfig?.Response?.PasswordRules);
    setSkeletonLoader(false);
  };

  useEffect(() => {
    if (bearerToken && bearerToken?.length > 800) {
      setOTPConfig();
    }
  }, [bearerToken]);

  return {
    email,
    password,
    currentStep,
    OTPExpiry,
    OTPLength,
    OTPAttempts,
    passwordRules,
    userDetails,
    skeletonLoader,
    setEmail,
    setPassword,
    setCurrentStep,
    setUserDetails,
    nextStep,
    prevStep,
  };
};
export default usePasswordRecovery;
